import _classCallCheck from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as base64url from '../runtime/base64url.js';
import { decoder } from '../lib/buffer_utils.js';
import { JWTInvalid } from '../util/errors.js';
import jwtPayload from '../lib/jwt_claims_set.js';
import { ProduceJWT } from './produce.js';
export var UnsecuredJWT = /*#__PURE__*/function (_ProduceJWT) {
  _inherits(UnsecuredJWT, _ProduceJWT);
  var _super = _createSuper(UnsecuredJWT);
  function UnsecuredJWT() {
    _classCallCheck(this, UnsecuredJWT);
    return _super.apply(this, arguments);
  }
  _createClass(UnsecuredJWT, [{
    key: "encode",
    value: function encode() {
      var header = base64url.encode(JSON.stringify({
        alg: 'none'
      }));
      var payload = base64url.encode(JSON.stringify(this._payload));
      return "".concat(header, ".").concat(payload, ".");
    }
  }], [{
    key: "decode",
    value: function decode(jwt, options) {
      if (typeof jwt !== 'string') {
        throw new JWTInvalid('Unsecured JWT must be a string');
      }
      var _jwt$split = jwt.split('.'),
        encodedHeader = _jwt$split[0],
        encodedPayload = _jwt$split[1],
        signature = _jwt$split[2],
        length = _jwt$split.length;
      if (length !== 3 || signature !== '') {
        throw new JWTInvalid('Invalid Unsecured JWT');
      }
      var header;
      try {
        header = JSON.parse(decoder.decode(base64url.decode(encodedHeader)));
        if (header.alg !== 'none') throw new Error();
      } catch (_a) {
        throw new JWTInvalid('Invalid Unsecured JWT');
      }
      var payload = jwtPayload(header, base64url.decode(encodedPayload), options);
      return {
        payload: payload,
        header: header
      };
    }
  }]);
  return UnsecuredJWT;
}(ProduceJWT);